/* NOVALTRIX v1 — menu mobile et barre d'appel à l'action fixe sur mobile. */
(function(){
  function init(){
    var b = document.querySelector('[data-nvx-menu]');
    var p = document.getElementById('nvx-menu');
    if (b && p) {
      b.addEventListener('click', function(){
        var open = b.getAttribute('aria-expanded') === 'true';
        b.setAttribute('aria-expanded', String(!open));
        p.hidden = open;
        b.textContent = open ? 'Menu' : 'Fermer';
      });
    }
    var bar = document.querySelector('[data-nvx-bar]');
    if (!bar) return;
    document.body.classList.add('has-bar');
    var hero = document.querySelector('[data-nvx-hero]');
    var fin = document.querySelector('[data-nvx-fin]');
    var past = !hero, inFin = false;
    function up(){ bar.classList.toggle('is-on', past && !inFin); }
    if ('IntersectionObserver' in window) {
      if (hero) new IntersectionObserver(function(e){ past = !e[0].isIntersecting; up(); }).observe(hero);
      if (fin) new IntersectionObserver(function(e){ inFin = e[0].isIntersecting; up(); }).observe(fin);
      up();
    } else { past = true; up(); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
